export const MAX_VOCA_COUNT = 500;

export const WORD_STATISTICS = {
  Entry: '표제어',
  Derived: '파생어',
  Reference: '참고단어',
  Related: '관련단어',
};

export const WORD_STATISTICS_VALUE = {
  Entry: 1,
  Derived: 2,
  Reference: 3,
  Related: 4,
};

export const ORDER_TYPE = {
  NONE: 0,
  BOOK: 1,
  ALPHABET: 2,
  RANDOM: 3,
};

export const USER_TYPE = {
  STUDENT: 10,
  TEACHER: 20,
};

export const VOCA_TYPE_STYLE = {
  SELECTED: {
    background: '#773DBD',
    color: '#fff',
    border: '1px solid #773DBD',
  },
  DISSELECTED: {
    background: '#fff',
    color: '#1E293B',
    border: '1px solid #A9B6CA',
  },
  DISABLED: {
    background: '#E2E8EF',
    color: '#A9B6CA',
    border: '1px solid #A9B6CA',
  },
  NORMAL: {
    background: '#CBD5E1',
    color: '#1E293B',
    border: '1px solid #CBD5E1',
  },
};

export const FOLDING = {
  unit: false,
  type: false,
  voca: false,
};

export const PAPER_SET = {
  set: false,
  print: false,
};

export const PAPER_TABS = {
  TEST_PAPER: 'testPaper',
  ANSWER: 'answer',
  ANSWER_TEST_PAPER: 'answerTestPaper',
  VOCABULARY_LIST: 'vocabularyList',
};

export const PAPER_CONFIG = {
  FONT_SIZE: {
    SMALL: 7,
    NORMAL: 9,
    LARGE: 11,
  },
  LINE_SPACING: {
    SMALL: 0.8,
    NORMAL: 1,
    LARGE: 1.15,
  },
};

export const Spacing_Base = 15;

export const FontSize_Css_Plus = 3;

export const SUBJECTS = {
  A: '※ 주어진 영단어를 보고 빈칸에 알맞은 한글 뜻을 쓰세요.',
  B: '※ 주어진 한글 뜻을 보고 빈칸에 알맞은 영단어를 쓰세요',
  C: '※ 예문의 빈칸에 들어갈 알맞은 영단어를 쓰세요.',
  D: '※ 다음 영단어의 유의어 또는 반의어를 쓰세요.',
  E: '※ 다음 영단어의 파생어를 쓰세요.',
};

export const AUDIO_PAPER_TYPE = {
  ENG: 1,
  ENG_KOR: 2,
  KOR: 3,
};

export const Is2ndRange = true; // 2차 범위
